import React, { useState } from 'react';
import ModalComponent from "../../../../../misc/ModalComponent";
import { useParams } from 'react-router-dom';
import { DeleteOneRosterCombineTeam } from '../../../../../../store/OneRoster/OneRosterCombineTeamAction';
import StatusCode from '../../../../../../util/StatusCode';
import { CoreOneRosterConfigurationCombinedTeam } from '../../../../../../models/CoreOneRosterConfigurationCombinedTeam';
import { useTranslation } from 'react-i18next';


interface OneRosterCombineTeamDeleteProps {
    isOpen: boolean
    toggleModal: () => void
    success: (success: boolean) => void
    team: CoreOneRosterConfigurationCombinedTeam
    disabled: boolean
}

const OneRosterCombineTeamDelete: React.FC<OneRosterCombineTeamDeleteProps> = (props) => {
    const { moduleId } = useParams();
    const [status, setStatus] = useState<StatusCode>(StatusCode.NONE);
    const { t } = useTranslation(['configuration', 'common']);

    const deleteCombinedTeam = () => {
        if (moduleId) {
            setStatus(StatusCode.PENDING);
            DeleteOneRosterCombineTeam(moduleId, props.team)
                .then(x => {
                    setStatus(StatusCode.COMPLETE)
                    props.success(true)
                    setTimeout(() => {
                        props.toggleModal()
                    }, 1500)
                })
                .catch(error => {
                    setStatus(StatusCode.ERROR)
                })
        }
    }

    return (
        <ModalComponent
            isOpen={props.isOpen}
            toggleModal={() => props.toggleModal()}
            header={t('oneRosterConfiguration.combineTeam.title', { ns: 'configuration' })}
            update={deleteCombinedTeam}
            disabled={props.disabled}
            confirm={t('action.confirm', { ns: 'common' })}
            cancel={t('action.cancel', { ns: 'common' })}
            saveStatus={status}
        >

            <p>{t('oneRosterConfiguration.combineTeam.delete', { ns: 'configuration' })} "{props.team.displayName}"?</p>

        </ModalComponent>)
}

export default OneRosterCombineTeamDelete;
